import { render, staticRenderFns } from "./SpinnerDots.vue?vue&type=template&id=84bf1620"
import script from "./SpinnerDots.vue?vue&type=script&lang=js"
export * from "./SpinnerDots.vue?vue&type=script&lang=js"
import style0 from "./SpinnerDots.vue?vue&type=style&index=0&id=84bf1620&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports